// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  headLang: {
    title: "商戶管理後台",
    welcome: "欢迎您，",
    changePassword: "修改密碼",
    logout: "退出登錄",
    updatePassword: "修改密碼",
    oldPassword: "舊密碼",
    newPassword: "新密碼",
    surePassword: "確認新密碼",
    chooseShop: "請選擇門店",
    currentShop: "當前門店：",
    notChangeShop: "不切換",
    changeShop: "切換門店"
  },
  index: {
    basicInfo: "基本信息",
    accountBalance: "賬戶餘額",
    setAmount: "可結算金額",
    frozenAmount: "結算中金額",
    storeManagement: "店鋪管理",
    amountManagemnet: "賬戶管理",
    orderFlow: "訂單流水",
    receiptCode: "收款QRCode",
    download: "開發文檔",
    noticeMessage: "通知消息",
    wdTip: "未读消息数量",
    refundReview: "退款審核",
    reviewTip: "待审核的退款数量",
    transaction: "交易匯總",
    tranAmount: "交易金額",
    tranJe: "交易淨額",
    paySuccessAmount: "支付成功金額",
    paySuccessNum: "支付成功筆數",
    refundAmount: "退款金額",
    tranNum: "交易筆數",
    refundNum: "退款筆數",
    YrefundAmount: "已退款金額",
    ZrefundAmount: "退款中金額",
    TrefundOrderNum: "退款訂單數",
    Getting: "歡迎使用 WISH PAY 商戶平臺，祝您財源廣進，生意興隆！"
  },
  shInfo: {
    saoQrCodeTip: "資料審核通過後掃描QR Code綁定",
    CPreview: "取消預覽",
    Preview: "預覽信息",
    keyTip: "以上KYB信息是商戶本人提交且確認無誤",
    BusinessInfo: "商戶資料",
    Documentupload: "上傳的證件及相片",
    Currencytype: "貨幣類型",
    BankAccountType: "銀行賬戶類型",
    BankCertificate: "銀行證明文件",
    BranchNumber: "分行編號",
    bankNo: "銀行編號",
    Holdername: "持戶人名稱",
    BillBankData: "銀行戶口資料",
    skData: "收款資料",
    BillingCycle: "結算週期",
    SHHB: "收款貨幣",
    JSHB: "結算貨幣",
    Storeinformation: "店鋪資料",
    contactJob: "負責人職位",
    principal: "負責人",
    addTime: "添加時間",
    Businessnumber: "商業登記號",
    basis: "基礎信息",
    merchantNo: "QR No.",
    merchantName: "商戶名稱",
    shortName: "商户簡稱",
    phone: "手機號碼",
    Referrer: "推薦員工",
    ReferrerPhone: "推薦員工手機號碼",
    bindRefPhone: "綁定推廣員工",
    refTip: "提示：手機號必須是真實有效的員工,無需輸入手機區號。",
    merchantState: "審核狀態",
    merchantGradeName: "商戶等級",
    address: "詳細地址",
    mobile: "聯繫電話",
    shMobile: "商戶電話",
    contactEmail: "電郵賬戶",
    contactName: "負責人姓名",
    contactMobile: "負責人手機",
    idCardNumber: "身份證號碼",
    loginNum: "登錄賬號",
    loginPassword: "登錄密碼",
    industryName: "行業",
    class: "經營類別",
    introduction: "商戶簡介",
    jsInfo: "結算信息",
    openName: "開戶名稱",
    openBank: "開戶銀行",
    openNumber: "銀行卡號",
    jsMode: "結算方式",
    zjData: "證件資料",
    idCardFontImageUrl: "身份證正面照",
    idCardBackImageUrl: "身份證背面照",
    brImageUrl: "商業登記照片",
    bankCardImageUrl: "銀行證明文件相片",
    brandImageUrl: "門頭招牌照片",
    roomImageUrl: "店鋪環境-收銀台相片",
    otherImageUrl: "其他相片",
    payInfo: "支付通道信息",
    Systatus: "使用狀態",
    tdNum: "通道編號",
    tdName: "通道名稱",
    tdRate: "结算费率",
    changeData: "修改資料",
    changeMobile: "更改手機號",
    sscompany: "所屬機構",
    ssAgent: "所屬代理",
    keys: "支付Key",
    loginInfo: "登錄信息",
    others: "其它",
    auto: "自動生成",
    tip: "10-25個字符",
    upload: "上傳",
    tjCheck: "提交審核",
    changePhone: "更換手機號",
    phoneNumber: "當前手機號",
    getCode: "獲取驗證碼",
    code: "驗證碼",
    NewPhone: "新手機號",
    Captcha: "圖形驗證碼",
    leixing: "商户类型",
    ciImageUrl: "公司註冊證書",
    bankStatementFileUrl: "银行流水文件照片",
    shopOne: "店铺环境-第一張",
    shopTwo: "店铺环境-第二張",
    ProtocolCheckedText: "我已閱讀並同意遵守協議",
    xieyiTitle: "《Wish Pay商戶服務使用條款》",
    WishPayServiceAgreement: "《Wish Pay服務協議》",
    shengmingText: "《個人戶口結算聲明書》",
    gsShengmingText: "《有限公司結算聲明書》",
    CumulativeBounty: "累計獲得賞金",
    AccountOpening: "開戶賞金",
    DividendBonus: "分潤賞金",
    DevelopedMerchant: "已发展的商户",
    CateringMerchant: "餐飲商户",
    NonCatering: "非餐饮商户",
    MyInvitationCode: "我的邀請碼",
    shTotal: "按商戶匯總",
    mxTotal: "按賞金明細",
    bountyAmount: "賞金金額合計",
    rTime: "註冊時間",
    srTime: "收益時間",
    sjtype: "賞金類型",
    sourceName: "來源商戶名稱",
    sjje: "賞金金額",
    ServiceFeeRate: "當前服務費",
    SetServiceFeeRate: "設置服務費",
    SelectFw: "選擇範圍：0~5%",
    ssmd: "所屬門店",
    ssjs: "所屬角色",
    dyxm: "店員姓名",
    dysjh: "店員手機號",
    xzdy: "新增店員",
    editzx: "修改資訊",
    changeM: "更換手機",
    dxyzm: "短信驗證碼",
    qrxz: "確認新增",
    qrxg: "確認修改",
    addmd: "新增門店"
  },
  zhInfo: {
    Settlement: "發起結算",
    jsLog: "結算記錄",
    sqTime: "申請時間",
    jsNum: "結算單號",
    txStatus: "提現狀態",
    skBank: "收款銀行",
    jsStatus: "結算狀態",
    jsMoney: "結算金額",
    fee: "手續費",
    sjMoney: "實際結算金額",
    kyMoney: "結算後可用餘額",
    jsBank: "結算銀行名稱",
    jsBankNum: "結算銀行卡號",
    payee: "收款人",
    note: "備註信息",
    dkTime: "打款時間",
    shAcount: "收款賬戶",
    bankName: "銀行名稱",
    banknumber: "銀行卡號",
    dqMoney: "當前可結算金額",
    allMoney: "全部結算",
    dkInfo: "打款信息",
    bankZzPhoto: "銀行轉賬照片",
    NoPhoto: "暫無照片"
  },
  ddInfo: {
    jyTime: "交易時間",
    jyDate: "交易日期",
    payTd: "支付通道",
    jyStatus: "交易狀態",
    ptOrderNum: "平台訂單號",
    payTdOrderNum: "支付通道訂單號",
    paySuccessAmount: "支付成功金額",
    paySuccessNum: "支付成功筆數",
    tkSuccessNum: "退款成功筆數",
    orderStatus: "訂單狀態",
    orderAmount: "訂單金額",
    jyType: "交易類型",
    payTdNum: "支付通道編號",
    applyTk: "申請退款",
    orderDetail: "訂單詳情",
    shOrder: "商戶訂單號",
    applyUserName: "退款申請人",
    orderContent: "訂單內容",
    payCountdown: "支付倒計時",
    paymentAddress: "訂單付款地址",
    waitingGenerate: "待生成",
    generatePaymentAddress: "生成付款地址",
    reset: "重置",
    copySuccess: "複製成功",
    copyFail: "複製失敗",
    pleaseInputOrderContent: "請先填寫訂單內容和金額",
    submitSuccess: "提交成功",
    pleaseInputRequired: "請填寫必填項",
    copyPaymentAddress: "複製付款地址",
    pleaseInputValidAmount: "請輸入有效金額",
    amountMustBeGreaterThanZero: "金額必須大於等於0.02",
    amountMustBeLessThanMillion: "金額必須小於1,000,000",
    generateSuccess: "生成成功，請複製訂單信息給付款方！",
    generateFail: "生成失敗，請稍後再試！",
    copyPaymentInfo: "複製付款信息",
    merchantOrderNo: "商戶訂單號"
  },
  tkInfo: {
    tkOrderNum: "退款訂單號",
    payOrderNum: "支付訂單號",
    tkStatus: "退款狀態",
    tkTotal: "退款總額",
    tkyy: "退款原因",
    tkApplyTime: "退款申請時間",
    tkFulfilTime: "退款完成時間",
    dqRefund: "可退款金額",
    allRefund: "全部退款",
    tkTip: "溫馨提示：退款金額最多輸入2位小數位",
    errorMessage1: "小数点后最多保留两位",
    errorMessage2: "不能大於當前可退款金額",
    tkSuccess: "申請成功",
    tkCheck: "確定審核/駁回該筆退款申請嗎？",
    exportTip: "導出的記錄數據為已支付成功的交易流水",
    errorMessage3: "請選擇導出流水交易時間"
  },
  shrjInfo: {
    slMechanism: "受理機構",
    jyTotalMoney: "交易總金額",
    tkTotalMoney: "退款總金額",
    TrAmount: "交易分润金额",
    tkTotalNum: "退款總筆數"
  },
  ewm: {
    tipTitle: "掃QRCode付款",
    shName: "商戶名稱顯示",
    showAll: "展示全稱",
    showjc: "展示簡稱",
    noShow: "不展示",
    background: "背景顏色",
    payModeShow: "支付方式展示",
    ewmLogo: "QRCode LOGO",
    wx: "微信",
    alipay: "支付寶",
    downloadQCode: "下載QRCode",
    gdje: "固定金額",
    ddje: "訂單金額",
    shopAll: "店鋪全稱",
    shopShort: "店鋪簡稱",
    validTime: "有效時間",
    alwaysValid: "一直有效",
    tradeContent: "交易內容",
    visibleToPayer: "該內容付款人可見",
  },
  config: {
    scanQR: "聚合碼支付",
    unionpay: "雲閃付支付",
    wechatpay: "微信支付",
    alipaypay: "支付寶支付",
    orderPayment: "訂單支付",
    copy: "複製",
    minutes: "分鐘",
    bhfwf: "該金額不含商家設置的服務費",
    unionPayTitle: "雲閃付QR Code",
    qrCodeDisplay: "QR Code顯示：",
    collectionAmount: "收款金額",
    collectionAmountLabel: "收款金額：",
    generateUnionPayQR: "生成雲閃付QR",
    generateWechatPayQR: "生成支付QR",
    generateAlipayQR: "生成支付QR",
    downloadQRCode: "下載QR Code",
    unionPayNotEnabled: "雲閃付通道未開通",
    wechatPayNotEnabled: "微信主掃支付通道未開通",
    alipayNotEnabled: "支付寶主掃支付通道未開通",
    contactNotice: "請聯繫您的業務經理或官方客服申請開通雲閃付通道",
    contactNoticeWechat: "請聯繫您的業務經理或官方客服申請開通微信主掃支付通道",
    contactNoticeAlipay: "請聯繫您的業務經理或官方客服申請開通支付寶主掃支付通道",
    contactPhone: "電話：852 21170503",
    contactEmail: "電郵：service@wishpay-global.com",
    acknowledged: "我已知曉",
    downloadSuccess: "下载成功！",
    qrGenerateSuccess: "QR Code生成成功，請下載併發送給付款方。",
    qrExpireNotice: "請注意，該二維碼在支付完成後將自動失效。",
    payAmountText: "付款金額",
    orderContentText: "商品或備註信息",
    payWalletLabel: "支付錢包：",
    alipayWallet: "支付寶"
  },
  onlineOrder: {
    title: "線上交易訂單",
    createTitle: "創建線上訂單",
    status: "訂單狀態",
    actualAmount: "實際付款金額",
    payMethod: "支付方式",
    orderContent: "訂單內容",
    orderNo: "訂單號",
    deliveryInfo: "交貨信息",
    time: "時間",
    operate: "操作",
    view: "查看",
    ship: "出貨",
    shipTitle: "出貨",
    all: "全部",
    pendingPayment: "待支付",
    pendingShipment: "待發貨",
    shipped: "已發貨",
    canceled: "已取消",
    completed: "已完成",
    keywordPlaceholder: "商戶訂單號/買家信息",
    search: "查詢",
    noDelivery: "無",
    shipMethod: "出貨方式",
    shipMethodLogistics: "物流出貨",
    shipMethodSelf: "非物流出貨",
    shipMethodSelfTip: "(門店自提/送貨上門/服務完成)",
    logisticsPlatform: "物流平台",
    logisticsNo: "物流單號",
    deliveryProof: "交貨憑證",
    uploadDeliveryProof: "請上傳物流單據",
    shipConfirm: "確認出貨",
    shipCancel: "取消",
    shipCancelTip: "確定取消出貨嗎？",
    shipSuccess: "出貨成功",
    shipFail: "出貨失敗",
    pleaseEnterLogisticsPlatform: "請輸入物流平台名稱",
    pleaseEnterLogisticsNo: "請輸入物流單號",
    pleaseUploadProof: "請上傳交貨憑證",
    proofView: "放大查看",
    proofDelete: "刪除",
    proofMaxTip: "最多上傳 3 張憑證圖片",
    imageTypeError: "請上傳圖片文件",
    imageSizeError: "圖片大小不能超過 2MB",
    createTime: "創建",
    payTime: "支付",
    shipTime: "發貨",
    userPickupMethod: "用戶選擇取貨方式",
    orderDetail: "訂單詳情",
    buyerInfo: "買家信息",
    copyAll: "一鍵複製",
    buyerName: "姓名",
    buyerPhone: "電話",
    buyerAddress: "收貨地址",
    productInfo: "商品信息",
    productTotal: "商品總額",
    shippingFee: "運費",
    storeDiscount: "店鋪優惠",
    actualPay: "實際支付",
    deliveryMethod: "交貨方式",
    payMethodLabel: "支付方式",
    createTimeLabel: "訂單創建時間",
    payTimeLabel: "訂單支付時間",
    customerRemark: "顧客備註",
    noRemark: "無",
    orderSource: "訂單來源",
    orderPayLink: "複製支付鏈接",
    orderPay: "訂單支付",
    close: "關閉",
    editBuyer: "修改買家",
    orderAmount: "訂單金額",
    orderInfo: "訂單信息",
    copySuccess: "複製成功",
    copyFail: "複製失敗",
    buyerInfoEditTitle: "買家信息",
    buyerNameLabel: "收貨人：",
    buyerNamePlaceholder: "請輸入收貨人名字",
    buyerNameRequired: "請輸入收貨人名字",
    buyerNameMax: "收貨人名字最多20字",
    buyerPhoneLabel: "手機號：",
    buyerPhonePlaceholder: "請輸入收貨人手機號",
    buyerPhoneRequired: "請輸入收貨人手機號",
    buyerPhoneMax: "手機號最多20位",
    buyerRegionLabel: "所在地區：",
    regionPlaceholder: "請選擇省/市/區",
    regionRequired: "請選擇所在地區",
    provincePlaceholder: "省",
    cityPlaceholder: "市",
    districtPlaceholder: "區",
    buyerAddressLabel: "詳細地址：",
    buyerAddressPlaceholder: "請輸入詳細地址",
    buyerAddressRequired: "請輸入詳細地址",
    buyerAddressMax: "詳細地址最多200字",
    buyerEditCancel: "取消",
    buyerEditConfirm: "確認修改",
    buyerEditSuccess: "修改成功"
  },
  md: {
    shfwf: "商戶服務費",
    shcode: "商戶編號",
    wechatNo: "Wechat ID",
    suoshu: "所屬總店",
    mendianType: "門店類型",
    jsFee: "結算費率",
    MinimumAmount: "最少結算金額",
    zd: "總店",
    fd: "分店",
    skzl: "收款資料",
    lymc: "來源名稱",
    mdlx: "門店類型",
    lylx: "來源類型"
  },
  public: {
    startDate: "開始日期",
    to: "至",
    endDate: "結束日期",
    inquire: "查詢",
    clear: "清空",
    NoNum: "序號",
    operating: "操作",
    pleaseEnter: "請輸入",
    pleaseChoose: "請選擇",
    look: "查看",
    edit: "編輯",
    del: "刪除",
    ty: "停用",
    qy: "啟用",
    sh: "審核",
    bh: "駁回",
    detail: "訂單詳情",
    close: "關閉",
    save: "保存",
    back: "返回",
    define: "確定",
    cancel: "取消",
    cancelSave: "取消保存",
    noTip: "暫無消息",
    prompt: "提示",
    successMsg: "操作成功",
    cancelMsg: "已取消",
    export: "導出流水"
  },
  sceneTip: {
    offlineTag: "線下場景",
    onlineTag: "線上場景",
    scanQR: "聚合碼適用於門店收款、面對面掃碼等線下交易場景。 顧客使用微信或支付寶掃描同一二維碼即可完成支付，一碼多用。",
    orderPayment: "鏈接支付 適用於獨立站私域客群、線上聊單、郵件溝通等線上交易場景。其原理與 PC 網站、H5 商城、APP 中的支付鏈接一致，用戶點擊支付按鈕後跳轉至支付頁面完成付款，集成方式靈活。生成的支付鏈接訂單可在本頁面進行發貨管理。線上費率詳情請諮詢您的業務經理。",
    wechatPay: "微信活碼屬於面對面收款方式，為動態生成的一次性付款碼，掃碼直接拉起支付，快捷且成功率高，可有效規避因聚合收款碼頻繁使用而引發的風控，適合線下高頻收款場景，亦可作為聚合碼支付攔截時的備用替代方案。",
    alipayPay: "支付寶活碼屬於面對面收款方式，為動態生成的一次性付款碼，掃碼直接拉起支付，快捷且成功率高，可有效規避因聚合收款碼頻繁使用而引發的風控，適合線下高頻收款場景，亦可作為聚合碼支付攔截時的備用替代方案。"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js